import React from 'react';
import I18n from '../I18n';
import {Checkbox} from 'rctui';

const Mask = React.createClass({
  displayName: 'Form.Mask',

  getDefaultProps: function () {
    return {
      disabled: false,
      available: null,
      options: [],
      name: '',
      value: ''
    };
  },

  propTypes: {
    name: React.PropTypes.string
  },

  onChange: function (value, dummy, checked) {
    let currentValue;
    if (value === Constants.Diff) {
      currentValue = checked ? Constants.Diff : 0
    } else {
      let itemValue = parseInt(value);
      currentValue = parseInt(this.props.value);

      if (checked && !this.hasMask(itemValue) || !checked && this.hasMask(itemValue)) {
        currentValue ^= itemValue;
      }
    }

    this.props.onChange(this.props.name, currentValue);
  },

  hasMask: function (value) {
    return this.props.value == value || (this.props.value & value) === value;
  },

  isAvailable: function (value) {
    return (this.props.available == null || (this.props.available & value) === value);
  },

  render: function () {
    let options = this.props.options;

    if (this.props.value === Constants.Diff) options = [{value: Constants.Diff, label: Constants.Diff}].concat(options);

    let optionNodes = options.map(function (option, key) {

      let checked = this.hasMask(option.value);

      return <label key={key}>
        <Checkbox
          onChange={this.onChange.bind(this, option.value)}
          checked={checked}
          readOnly={(option.value !== Constants.Diff && this.props.value === Constants.Diff) || !this.isAvailable(option.value)}>
          <I18n message={option.label}/>
        </Checkbox>
      </label>;
    }.bind(this));

    return (
      <div className="block-checkbox">
        {optionNodes}
      </div>
    );
  }
});

export default Mask;



// WEBPACK FOOTER //
// ./src/js/Component/Form/Mask.jsx